
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"10.5","height":"14","viewBox":"0 0 10.5 14"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"data-name":"Path 151265","d":"M5.25 0A5.251 5.251 0 000 5.25c0 2.105.738 2.707 4.7 8.477a.684.684 0 001.094 0C9.762 7.957 10.5 7.355 10.5 5.25A5.251 5.251 0 005.25 0zm0 12.961C1.422 7.41.875 7 .875 5.25A4.388 4.388 0 015.25.875 4.388 4.388 0 019.625 5.25c0 1.75-.52 2.16-4.375 7.711zm0-9.9A2.194 2.194 0 003.062 5.25 2.194 2.194 0 005.25 7.438 2.194 2.194 0 007.437 5.25 2.194 2.194 0 005.25 3.063zm0 3.5A1.331 1.331 0 013.937 5.25 1.331 1.331 0 015.25 3.938 1.331 1.331 0 016.562 5.25 1.331 1.331 0 015.25 6.563z","fill":"#0079f2"}})])
          )
        }
      }
    